import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import "./ZoneTag.css";


class ZoneTag extends Component {


    render() {
        const text = this.props.text;
        let style = {};
        if (this.props.backgroundColor) {
            style.backgroundColor = this.props.backgroundColor;
        }
        if (this.props.color) {
            style.color = this.props.color;
        }
        return (
            <span className="zone-tag" style={style}>
                {text}
            </span>

        );
    }
}

function mapStateToProps(store) {
    return {}
}

export default connect(mapStateToProps)(injectIntl(ZoneTag));